import { createReducer, on } from '@ngrx/store';
import * as PettyCashActions from './petty-cash.actions';
import { PettyCashBalance } from '../../../../features/gse/petty-cash/models/petty-cash.model';
import { PettyCashAccountResponse } from '../../../../api/gse/models/petty-cash-account-response';

export interface PettyCashState {
  balance: PettyCashAccountResponse | null;
  loading: boolean;
  error: string | null;
  updateSuccessVersion: number;
}

export const initialState: PettyCashState = {
  balance: null,
  loading: false,
  error: null,
  updateSuccessVersion: 0,
};

export const pettyCashReducer = createReducer(
  initialState,
  on(PettyCashActions.loadPettyCashBalance, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PettyCashActions.loadPettyCashBalanceSuccess, (state, { response }) => ({
    ...state,
    balance: response,
    loading: false,
    error: null,
  })),
  on(PettyCashActions.loadPettyCashBalanceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(PettyCashActions.updatePettyCashBalance, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(PettyCashActions.updatePettyCashBalanceSuccess, (state, { response }) => ({
    ...state,
    balance: response,
    loading: false,
    error: null,
    updateSuccessVersion: state.updateSuccessVersion + 1,
  })),
  on(PettyCashActions.updatePettyCashBalanceFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
